import permissions from "app/permissions";
import { EmployeeServicePath, STAFF_REQUEST } from "utils/constants";
import { resources as PendingRequests } from "./PendingRequests";
import { resources as RequestsHistory } from "./RequestsHistory";
import { tenants } from "utils/tenants";
import GroupIcon from "@mui/icons-material/Group";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU, tenants.SU],
  icon: <GroupIcon />,
  name: EmployeeServicePath + STAFF_REQUEST,
  title: "Служителски заявки",
  permission: permissions.canPreviewStaffRequests,
  subMenu: [PendingRequests, RequestsHistory],
};
